const rollingRefreshIntervals = Object.freeze({
  0: 'Audience_Segment_Form_Rolling_RefreshInterval_1h'
})

export { rollingRefreshIntervals }



// WEBPACK FOOTER //
// ./src/modules/audiences/enum/RollingRefreshIntervalEnums.js